import createReducer from 'utils/redux/createReducer'

const initialState = ''

export default createReducer(initialState, {
	ERROR: (state, action) => action.data
  , LOGIN: (state, action) => ''
  , LOGIN_FAIL: (state, action) => action.data
})



// WEBPACK FOOTER //
// ./src/reducers/error.js